"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FilenameInput = _interopRequireDefault(require("FileManagerLib/components/browser/FilenameInput"));

var Filename =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Filename, _Component);

  function Filename(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Filename);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Filename).call(this, props));
    _this.state = {
      filename: props.file.get('name')
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Filename, [{
    key: "handleChange",
    value: function handleChange(event) {
      this.setState({
        filename: event.target.value
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      var _this$props = this.props,
          onUpdate = _this$props.onUpdate,
          file = _this$props.file;
      var filename = this.state.filename;

      if (filename && filename !== file.get('name')) {
        onUpdate(filename);
      } else {
        this.setState({
          filename: file.get('name')
        });
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var _this$props2 = this.props,
          onUpdate = _this$props2.onUpdate,
          file = _this$props2.file;
      var filename = this.state.filename;

      if (event.key === 'Enter' && filename && filename !== file.get('name')) {
        onUpdate(filename);
        this.input.blur();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var filename = this.state.filename;
      return _react.default.createElement(_FilenameInput.default, {
        ref: function ref(c) {
          _this2.input = c;
        },
        value: filename,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown
      });
    }
  }]);
  return Filename;
}(_react.Component);

exports.default = Filename;
Filename.propTypes = {
  file: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  onUpdate: _react.PropTypes.func.isRequired
};
module.exports = exports.default;